// extracted by mini-css-extract-plugin
export default {"select-wrapper":"style_select-wrapper__CmkVi","label":"style_label__ex27k","select":"style_select__iox5E","error":"style_error__C+ful","selector":"style_selector__8TSzm"};